/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_NovemberInputs */

const he_month_november = /** @type {(inputs: Month_NovemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נובמבר`)
};

const en_month_november = /** @type {(inputs: Month_NovemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`November`)
};

/**
* | output |
* | --- |
* | "November" |
*
* @param {Month_NovemberInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_november = /** @type {((inputs?: Month_NovemberInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_NovemberInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_november(inputs)
	return en_month_november(inputs)
});